import { render, staticRenderFns } from "./MyContracts.vue?vue&type=template&id=3a1f4868&scoped=true&"
import script from "./MyContracts.vue?vue&type=script&lang=ts&"
export * from "./MyContracts.vue?vue&type=script&lang=ts&"
import style0 from "./MyContracts.vue?vue&type=style&index=0&id=3a1f4868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1f4868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
